"use strict";
/**
 * QVET Types
 *
 * Type definitions for QVET system integration.
 * Constants are in constants/qvet-*.ts
 * Helpers are in utils/qvet-catalog.helpers.ts
 */
Object.defineProperty(exports, "__esModule", { value: true });
